export default __webpack_public_path__ + "134849d925c3c4c89fdba292d94bc9fd.svg";